import React from 'react';
import { SVGComp, PathComp } from '../../components/Svgs';
import { useTheme } from '@hmsexp/component-library';

const CheckCircleIcon = ({ width = '14', height = '14', viewBox = '0 0 14 14', stroke = useTheme().palette.common.white }) => {
  return (
    <SVGComp width={width} height={height} viewBox={viewBox} fill="none">
      <PathComp
        d="M13 6.45143V7.00343C12.9993 8.29729 12.5803 9.55624 11.8056 10.5925C11.0309 11.6288 9.94197 12.3869 8.70121 12.7538C7.46046 13.1206 6.13435 13.0766 4.92068 12.6282C3.70701 12.1798 2.67079 11.3511 1.96658 10.2657C1.26236 9.18025 0.927875 7.89627 1.01301 6.60522C1.09814 5.31417 1.59832 4.08523 2.43897 3.10168C3.27961 2.11813 4.41567 1.43266 5.67771 1.14752C6.93975 0.86238 8.26016 0.992836 9.442 1.51943M13 2.20343L7 8.20943L5.2 6.40943"
        stroke={stroke}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVGComp>
  );
};

export default CheckCircleIcon;
